import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { CommissionsService } from '@core/services/commissions.service';
import { GeneralsService } from '@core/services/generals.service';
import { ValidationsService } from '@core/services/validations.service';
import { Constants } from '@shared/class/constants.class';
import { Channel } from '@shared/interfaces/channel';
import { Commission } from '@shared/interfaces/commission';

@Component({
  selector: 'app-commissions-edit',
  templateUrl: './commissions-edit.component.html'
})
export class CommissionsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public commission: Commission;
  public commissionsList: Array<Channel> = [];
  public channelsList: Array<Channel> = [];
  public commissionForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private commissionsService: CommissionsService,
    public dialogRef: MatDialogRef<CommissionsEditComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      let channel: Channel;
      if (this.data.relationships.length) {
        this.data.relationships.forEach((element: any) => {
          channel = {
            id: element.id,
            name: element.attributes.name,
            idStatus: element.relationships.status.id,
            status: element.relationships.status.name
          };
          this.channelsList.push(channel);
        });
      }
      this.constants.title = this.appConfig.LANG.commissions.title;
      this.constants.action = this.data.action;
      this.commissionForm = new FormGroup(
        {
          idChannel: new FormControl('', Validators.required),
          startValue: new FormControl('', [
            Validators.required,
            Validators.maxLength(9),
            ValidationsService.isInvalidNumberValidator
          ]),
          endValue: new FormControl('', [
            Validators.required,
            Validators.maxLength(9),
            ValidationsService.isInvalidNumberValidator
          ]),
          fixValue: new FormControl('', [
            Validators.required,
            ValidationsService.isFixValueValidator
          ]),
          variableValue: new FormControl('', [
            Validators.required,
            ValidationsService.isVariableValueValidator
          ])
        },
        ValidationsService.validateRangeCommissions
      );
      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.commission = this.data.item;
        this.commissionForm.addControl(
          'id',
          new FormControl(this.commission.id, [Validators.required])
        );
        this.commissionForm.patchValue({
          idChannel: this.commission.idChannel,
          startValue: this.commission.startValue,
          endValue: this.commission.endValue,
          fixValue: this.commission.fixValue,
          variableValue: this.commission.variableValue
        });
      } else {
        if (this.channelsList.length <= 0) {
          this.constants.admitted = false;
        } else {
          this.constants.action = this.appConfig.ACTIONS.add.id;
          this.constants.title =
            this.appConfig.LANG.title.add + ' ' + this.constants.title;
        }
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.commissionForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.commissionsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
